import { cn } from "@/lib/utils";

export function ClearIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-2 text-white", className)}
      viewBox="0 0 8 8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.712 4.055a.077.077 0 010-.11l2.867-2.867a.465.465 0 00-.657-.656L4.055 3.287a.077.077 0 01-.11 0L1.08.422a.464.464 0 10-.657.656l2.866 2.867a.077.077 0 010 .11L.422 6.922a.464.464 0 00.657.656l2.866-2.867a.077.077 0 01.11 0l2.867 2.867a.464.464 0 10.656-.656L4.712 4.055z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SearchIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3.5 text-white", className)}
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.004 12.902L10.3 10.243"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <ellipse
        cx="6.457"
        cy="6.465"
        rx="5.457"
        ry="5.368"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
